import ActionTypes from 'store/actionTypes/admin/binomeLists';
import GetOrderValue from 'types/GetOrderValue';
import Tags from 'types/Tags';

export type List = 'main';

type SetPage = (list: List, page: number) => { type: ActionTypes; value: number };
export const setPage: SetPage = (_list, page) => ({
  type: ActionTypes.MAIN_SET_PAGE,
  value: page,
});

type SetSearch = (list: List, search: string) => { type: ActionTypes; value: string };
export const setSearch: SetSearch = (_list, search) => ({
  type: ActionTypes.MAIN_SET_SEARCH,
  value: search,
});

type SetTags = <TagColumnNames extends string>(
  list: List,
  tags: Tags<TagColumnNames>,
) => { type: ActionTypes; value: Tags<TagColumnNames> };
export const setTags: SetTags = (_list, tags) => ({
  type: ActionTypes.MAIN_SET_TAGS,
  value: tags,
});

type SetExportColumns = <Columns extends Record<string, boolean>>(
  list: List,
  exportColumns: Columns,
) => { type: ActionTypes; value: Columns };
export const setExportColumns: SetExportColumns = (_list, exportColumns) => ({
  type: ActionTypes.MAIN_SET_EXPORT_COLUMNS,
  value: exportColumns,
});

type SetTake = (list: List, take: number) => { type: ActionTypes; value: number };
export const setTake: SetTake = (_list, take) => ({
  type: ActionTypes.MAIN_SET_TAKE,
  value: take,
});

type SetOrder = <OrderValue extends GetOrderValue<string>>(
  list: List,
  order: OrderValue,
) => { type: ActionTypes; value: OrderValue };
export const setOrder: SetOrder = (_list, order) => ({
  type: ActionTypes.MAIN_SET_ORDER,
  value: order,
});